(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  function disclosure(container, heading, name) {
    if (!container || !heading || container.querySelector(':scope > .pdp-disclosure')) return;
    const details = document.createElement('details');
    details.className = 'pdp-disclosure';
    if (name) { details.name = name; details.dataset.pdpGroup = name; }
    const summary = document.createElement('summary');
    summary.append(heading);
    const body = document.createElement('div');body.className='pdp-disclosure__body';
    while(container.firstChild)body.append(container.firstChild);
    details.append(summary,body);container.append(details);
  }
  function enhance() {
  document.querySelectorAll('.ki-panel').forEach(panel => {
    panel.querySelectorAll('.ki-rows > li').forEach(row => {
      if (row.querySelector('.ki-disclosure')) return;
      const heading = row.querySelector('h4');
      if (!heading) return;
      const details = document.createElement('details');
      details.className = 'ki-disclosure';
      details.name = panel.id + '-ingredients';
      const summary = document.createElement('summary');
      const label = document.createElement('span');
      label.className = 'ki-summary-copy';
      label.append(heading);
      const benefit = row.querySelector('p > strong');
      if (benefit) {
        const text = document.createElement('span');
        text.className = 'ki-row-benefit type-body-sm';
        text.textContent = benefit.textContent;
        label.append(text);
        benefit.remove();
      }
      summary.append(label);
      const body = document.createElement('div');
      body.className = 'ki-disclosure-body';
      while (row.firstChild) body.append(row.firstChild);
      details.append(summary, body);
      row.classList.add('ki-row-enhanced');
      row.append(details);
    });
  });
  if (!desktop.matches) return;
  const protocol=document.querySelector('#koppa-protocol');
  if(protocol && !protocol.classList.contains('kp-purchase-refined')){
    disclosure(protocol.querySelector('.kp-inventory'),protocol.querySelector('.kp-inventory h2'));
    disclosure(protocol.querySelector('.kp-alternatives'),protocol.querySelector('.kp-alternatives > p'));
    const form=protocol.querySelector('.kp-restock form');
    if(form&&!form.closest('.pdp-signup')&&!form.querySelector('.form-status,.form__message')){
      const details=document.createElement('details');details.className='pdp-disclosure pdp-signup';
      const summary=document.createElement('summary');summary.className='kp-button kp-primary';summary.textContent=form.querySelector('button[type="submit"]')?.textContent.trim()||'';
      if(summary.textContent){form.before(details);details.append(summary,form);}
    }
  }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ki-inci-link],[data-protocol-inci-link]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (target?.tagName === 'DETAILS') {
      target.open = true;
      target.querySelector('summary')?.focus({preventScroll:true});
    }
  });
  enhance();
  desktop.addEventListener('change',event=>{enhance();document.querySelectorAll('.pdp-disclosure').forEach(d=>{if(event.matches&&d.dataset.pdpGroup)d.name=d.dataset.pdpGroup;else d.removeAttribute('name');d.open=!event.matches})});
  document.addEventListener('shopify:section:load',enhance);
})();
